import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { useState } from "react";
import { Button } from "risa-oasis-ui_v2";
import {
  copyDocumentsByPath,
  CopyDocumentsByPathPayload,
} from "../../../../api/postCall/copyDocumentsByPath";
import { ToastMessages } from "../../../../components/toasts/toastMessages";
import { FirestoreEnvironment } from "../../../../enums/firestoreEnvironment";

const DataMigration = () => {
  const [collectionPaths, setCollectionPaths] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleMigration = async () => {
    if (!collectionPaths.trim()) return;

    const paths = collectionPaths
      .split(",")
      .map((path) => path.trim())
      .filter((path) => path.length > 0);

    if (paths.length === 0) return;

    setIsLoading(true);

    const payload: CopyDocumentsByPathPayload = {
      document_paths: paths,
      source_environment: FirestoreEnvironment.PROD,
      target_environment: FirestoreEnvironment.DEV,
    };

    const response = await copyDocumentsByPath(payload);

    if (response.success) {
      const copiedCount = response.copied_count ?? 0;
      const notFoundCount = response.not_found_count ?? 0;

      if (notFoundCount > 0) {
        toast.error(
          `${copiedCount} document(s) migrated, ${notFoundCount} not found`,
        );
      } else {
        toast.success(`${copiedCount} document(s) migrated successfully`);
      }
    } else {
      toast.error(
        response.error ??
          response.message ??
          ToastMessages.DATA_MIGRATION_FAILURE,
      );
    }

    setIsLoading(false);
  };

  return (
    <div className="flex h-full w-full flex-col gap-4 overflow-hidden">
      <div className="text-base font-bold text-gray-900">Data Migration</div>

      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-gray-500">
          Collection Paths (comma-separated)
        </label>
        <textarea
          value={collectionPaths}
          onChange={(e) => setCollectionPaths(e.target.value)}
          placeholder="e.g., users, orders, config/settings"
          className="h-32 w-full resize-none rounded-lg border border-primaryGray-14 p-3 text-sm outline-none placeholder:text-primaryGray-8 disabled:cursor-not-allowed disabled:bg-gray-50"
          disabled={isLoading}
        />
      </div>

      <div>
        <Button
          disabled={isLoading || !collectionPaths.trim()}
          onClick={handleMigration}
          buttonType="primary"
          size="small"
        >
          {isLoading ? "Migrating..." : "Migrate Data from Prod to Dev"}
        </Button>
      </div>
    </div>
  );
};

export default DataMigration;
